<template>
  <el-row type="flex" align="middle" class="nav-header">
    <el-col :span="8" class="flex items-center">
      <router-link to="/" class="flex items-center">
        <img class="nav-logo" src="@/assets/layout/nav_logo.png" alt="logo" />
        <span class="title">{{ projectName }}</span>
      </router-link>
    </el-col>

    <el-col :span="16">
      <ul class="flex items-center justify-end">
        <li>
          <el-button type="primary" size="mini" :disabled="effectiveStatus" @click="handleSubmit">
            {{ title }}
            <span v-if="effectiveStatus">{{ progress }}%</span>
          </el-button>
        </li>
        <li>
          <el-dropdown @command="handleCommand">
            <span class="flex items-center">
              <img class="nav-avatar mr-5" src="@/assets/layout/nav_avatar.png" alt="avatar" />
              {{ employeeName }}
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="keyboardShortcuts">{{ $t('快捷键') }}</el-dropdown-item>
              <el-dropdown-item command="clearLocalCache">{{ $t('清除缓存') }}</el-dropdown-item>
              <el-dropdown-item command="changePassword">{{ $t('修改密码') }}</el-dropdown-item>
              <el-dropdown-item command="logout" divided>{{ $t('退出登录') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </el-col>
    <template v-if="visible">
      <ResetPassword :visible.sync="visible" />
    </template>
  </el-row>
</template>
<script>
  import i18n from '@/locale'
  import { mapActions, mapGetters } from 'vuex'
  import { ChangePwdStorage } from '@/utils/storage'
  import { projectName } from '@/config'
  import { GlobalEventType } from '@/constants'
  import { oneDeployment } from '@/api/config'
  export default {
    name: 'Header',
    computed: {
      ...mapGetters({
        employeeName: 'user/employeeName',
        belongCode: 'user/belongCode',
        employeeNo: 'user/employeeNo',
        noticeRemindTotalNums: 'notice/noticeRemindTotalNums',
      }),
      actionBarRoute() {
        return this.$router.match('/actionbar')
      },
    },
    components: {
      ResetPassword: () => import('@/components/reset-password'),
      // SelectLang: () => import('@/components/lang-select')
    },
    data() {
      return {
        projectName: i18n.t(projectName),
        visible: false,
        title: '一键生效',
        effectiveStatus: false,
        countdown: 12,
        progress: 0,
      }
    },
    async mounted() {
      const isNeedUpdatePwd = ChangePwdStorage.get()
      if (isNeedUpdatePwd) {
        setTimeout(() => {
          this.$mgAlert(
            i18n.t('密码已过期或密码强度较低，账号存在风险，请及时修改您的登录密码保障资料安全'),
            i18n.t('安全提示'),
            {
              showCancelButton: false,
              showClose: false,
              closeOnPressEscape: false,
            }
          ).then(() => {
            this.visible = isNeedUpdatePwd
          })
        })
      }
    },
    methods: {
      ...mapActions({
        logout: 'user/logout',
      }),
      async handleSubmit() {
        try {
          this.effectiveStatus = true
          this.startCountdown()
          const { data } = await oneDeployment({ type: 'www' })
          if (data && data[data.length - 1] == '脚本执行成功') {
            this.effectiveStatus = false
            this.$message.success('已生效')
          } else {
            this.effectiveStatus = false
            this.$message.error('生效失败')
          }
          clearInterval(this.interval)
        } catch (e) {
          clearInterval(this.interval)
          this.effectiveStatus = false
          // this.$message.success('已生效')
        }
      },
      startCountdown() {
        this.progress = 0
        this.countdown = 12
        this.interval = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--
            this.progress = parseInt(((12 - this.countdown) / 12) * 99)
          } else {
            clearInterval(this.interval)
            this.progress = 99
          }
        }, 1000)
      },
      handleCommand(command) {
        switch (command) {
          case 'logout':
            this.$mgAlert(
              i18n.t('您确定要退出{projectName}吗?', { projectName: this.projectName }),
              i18n.t('温馨提示'),
              {
                type: 'warning',
              }
            )
              .then(() => {
                return this.logout(true)
              })
              .then(() => {
                window.location.reload('/login')
              })
            break
          case 'changePassword':
            this.visible = true
            break
          case 'keyboardShortcuts':
            this.$root.$emit(GlobalEventType.KEYBOARD_SHORTCUTS)
            break
          case 'clearLocalCache':
            this.$mgConfirm(i18n.t('确定清除本地缓存?'), i18n.t('提示')).then(() => {
              LocalForage.clear()
            })
            break
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .nav-header {
    height: 100%;
    .nav-logo {
      height: 20px;
      margin-right: 10px;
    }
    .nav-avatar {
      width: 20px;
    }
    .title {
      font-size: 15px;
    }
    ul li {
      margin-left: 10px;
    }
  }
  .pda-download-qrcode {
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-height: 120px;
  }

  ::v-deep {
    .downloadCenter {
      .el-popover {
        padding: 0 !important;
      }
    }
    .hrefTitle {
      font-size: 14px;
      margin: 10px 0;
    }
    .hrefStyle {
      margin: 15px 0;
    }
  }
  ::v-deep {
    .el-badge__content {
      background-color: #e60012;
    }
  }
</style>
